// Package Imports
import { redirect } from '@tanstack/react-router'

// Core Imports
import { authEvents } from '@/core/lib/auth-events'
import { notify } from '@/core/lib/ui-bus'
import { getAuth, hasPermission } from '@/core/utils/auth-utils'

// Module Imports
import type { TPermissionKey } from '@/modules/role/role.types'

export type GuardCtx = { location: { href: string } }

export const requireAuth = async ({ location }: GuardCtx) => {
  const auth = await getAuth()
  if (!auth?.email) {
    throw redirect({
      to: '/',
      search: { status: 'requested', redirectTo: location.href },
    })
  }
  return auth
}

export const requirePublic = async () => {
  const auth = await getAuth()
  if (auth?.email) {
    throw redirect({ to: '/dashboard' })
  }
}

export const requirePermission =
  (permission: TPermissionKey) => async (ctx: GuardCtx) => {
    await requireAuth(ctx)
    const ok = await hasPermission(permission)
    if (!ok) {
      authEvents.emit('forbidden')
      throw redirect({ to: '/dashboard/forbidden' })
    }
  }

export const routeHasPermission = async (
  preload: boolean,
  permission: TPermissionKey,
  message: string
) => {
  if (preload) return
  const canAccess = await hasPermission(permission)
  if (!canAccess) {
    notify.error({ message: 'Yetkilendirme Hatası', description: message })
    throw redirect({ to: '/dashboard/forbidden' })
  }
}
